<template>
  <div>
    <span>
      <vs-button
        v-if="plas == '0'"
        style="
          border-radius: 5px;
          margin: 10px;
          padding-top: 0px;
          padding-bottom: 0px;
        "
        type="gradient"
        icon="edit"
        size="small"
        @click="gorevVer()"
        >İşleme Al</vs-button
      >
      <vs-button
        v-else
        color="success"
        style="
          border-radius: 5px;
          margin: 10px;
          padding-top: 0px;
          padding-bottom: 0px;
        "
        type="gradient"
        icon="edit"
        size="small"
        @click="gorevVer()"
        >İşleme Al</vs-button
      >
    </span>
    <vs-prompt
      title="Kullanıcıyı Görevlendir"
      acceptText="Görev Ver"
      cancelText="Vazgeç"
      :active.sync="activePrompt"
      @accept="kullaniciHareketiEkleGuncelle"
    >
      <div class="con-exemple-prompt">
        <span>Kullanıcı</span>
        <b-row>
          <b-col>
            <v-select
              v-model="secilenKullanici"
              :options="optionsKullanicilar"
              placeholder="Tezgahtar seçimi"
              label="name"
            ></v-select>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import vSelect from "vue-select";
import moment from "moment";
export default {
  data() {
    return {
      popupKartDetay: false,
      secilenKullanici: "",
      optionsKullanicilar: [],
      plas: "",
      activePrompt: false,
    };
  },
  created() {
    this.plas = Store.state.plasiyer;
  },
  components: {
    "v-select": vSelect,
  },
  methods: {
    yazdir() {
      setTimeout(this.yazdirBekle, 5000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe5");
    },
    kullaniciHareketiEkleGuncelle() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.secilenKullanici == "") {
        vs.notify({
          title: "Kullanıcı",
          text: "Kullanıcı seçimi yapmadınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        var today = new Date();
        var parsedToday = moment(String(today)).format("YYYYMMDD");
        vm.$root.$emit("setkartDetayiKullanici", vm.params.data);

        const args = {
          token: Store.state.tokenId,
          id: "",
          islem: "1",
          kullaniciId: vm.secilenKullanici.id,
          orderNumber: vm.params.data.orderNumber,
          role: vm.secilenKullanici.rol,
          islemKodu: vm.params.data.orderNumber + parsedToday,
          pazaryeri: "Ticimax",
        };
        console.log(args);
        soap.createClient(url, function (err, client) {
          client.kullaniciHareketiEkleGuncelle(args, function (err, result) {
            if (result.kullaniciHareketiEkleGuncelleResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            console.log(vm.params.data);
            vm.veriler = JSON.parse(result.kullaniciHareketiEkleGuncelleResult);
            if (vm.veriler.response == "Ok") {
              const args2 = {
                token: Store.state.tokenId,
                id: vm.veriler.jsonData.id,
                islem: "2",
                kullaniciId: vm.secilenKullanici.id,
                orderNumber: vm.params.data.orderNumber,
                role: vm.secilenKullanici.rol,
                islemKodu: vm.params.data.orderNumber + parsedToday,
                pazaryeri: "Ticimax",
              };
              soap.createClient(url, function (err, client) {
                client.kullaniciHareketiEkleGuncelle(
                  args2,
                  function (err, result) {
                    if (result.kullaniciHareketiEkleGuncelleResult == "-1") {
                      Store.dispatch("logout");
                      //this.$store.dispatch('login', payload)
                    }
                    vm.veriler = JSON.parse(
                      result.kullaniciHareketiEkleGuncelleResult
                    );
                    if (vm.veriler.response == "Ok") {
                      const args3 = {
                        token: Store.state.tokenId,
                        orderID: vm.params.data.orderId,
                        durumId: "2",
                      };
                      console.log(args3);
                      soap.createClient(url, function (err, client) {
                        client.siparisPaketGuncelleTransferSureci(
                          args3,
                          function (err, result) {
                            if (
                              result.siparisPaketGuncelleTransferSureciResult ==
                              "-1"
                            ) {
                              Store.dispatch("logout");
                              //this.$store.dispatch('login', payload)
                            }
                            console.log(result)
                            vm.veriler = JSON.parse(
                              result.siparisPaketGuncelleTransferSureciResult
                            );
                            console.log(vm.veriler);
                            if (vm.veriler.response == "Ok") {
                              vm.$root.$emit("setkullaniciGorevListesi");
                              vs.notify({
                                title: "Başarılı",
                                text: vm.veriler.message,
                                iconPack: "feather",
                                icon: "icon-alert-circle",
                                color: "success",
                                position: "top-center",
                              });
                            }
                          }
                        );
                      });
                    }
                  }
                );
              });
            }
          });
        });
      }
    },
    kullanciListe() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };

      soap.createClient(url, function (err, client) {
        client.kullanciListe(args, function (err, result) {
          if (result.kullanciListeResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.kullanciListeResult);
          let list = vm.veriler.jsonData;
          var durumFiltre = [];
          list.forEach((val, index) => {
            if (val.durum == 1 && vm.plas == 0) {
              if (val.rol == 5) {
                console.log("innnn");
                durumFiltre.push({
                  name: val.adSoyad,
                  id: val.id,
                  rol: val.rol,
                });
              }
            } else if (val.durum == 1 && vm.plas == 4) {
              if (val.rol == 4) {
                durumFiltre.push({
                  name: val.adSoyad,
                  id: val.id,
                  rol: val.rol,
                });
              }
            }
          });
          console.log(durumFiltre);
          vm.optionsKullanicilar = durumFiltre;
        });
      });
    },
    gorevVer() {
      // this.$root.$emit("setGuncellenecekKullanici", this.params.data);
      if (this.plas == "0") this.activePrompt = true;
      else if (this.plas == "4")
        this.$root.$emit("setkartDetayiKullanici", this.params.data);
      this.kullanciListe();
    },
  },
  beforeMount() {
    this.columnDefsKullaniciDetay = [
      {
        headerName: "Sipariş No",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Müşteri Ad Soyad",
        field: "orderCustomer",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kalem Adı",
        field: "orderItemName",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kalem Stok Kodu",
        field: "orderItemStockCode",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Sipariş Kalem Adı",
        field: "orderItemName",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kalem Adedi",
        field: "orderItemQuantity",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        width: 200,
        field: "",
        cellRendererFramework: "KullaniciGorevVermeButon",
        autoHeight: true,
      },
      {
        width: 200,
        field: "",
        cellRendererFramework: "SiparisYazdirButon",
        autoHeight: true,
      },
    ];
  },
};
</script>